import { useMemo } from "react";
import { array, mixed, object, string } from "yup";
import { PROOF_FILE } from "consts/ecommerce";
import { adult, fileSize, fileType } from "util/validators";
import { FormField } from "./types";

const useValidationSchema = () =>
    useMemo(() => (
        object().shape({
            [FormField.FullName]: string()
                .required()
                .trim()
                .min(1)
                .label('First Name'),

            [FormField.DateOfBirth]: string()
                .required()
                .nullable()
                .label('Date of Birth')
                .test(
                    'is-adult',
                    'You must be an adult to proceed',
                    adult()
                ),

            [FormField.Nationality]: array()
                .of(string())
                .nullable()
                .min(1, 'Select at least one Nationality')
                .label('Nationality'),

            [FormField.ResidentialAddress]: string()
                .required()
                .trim()
                .min(1)
                .label('Residential Address'),

            [FormField.LegalForm]: string()
                .required()
                .label('Legal Form'),

            [FormField.IdentityFileKey]: mixed()
                .required()
                .test('fileSize', 'File size is too large', fileSize(PROOF_FILE.maxSize))
                .test('fileType', 'Unsupported file format', fileType([
                    'image/png',
                    'image/jpeg',
                    'application/pdf'
                ]))
                .label('Identity Document'),

            [FormField.AddressFileKey]: mixed()
                .required()
                .test('fileSize', 'File size is too large', fileSize(PROOF_FILE.maxSize))
                // .test('fileType', 'Unsupported file format', fileType(PROOF_FILE.supportedFormats))
                .label('Proof of Residential Address')
        })
    ), []);

export default useValidationSchema;
